// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2s9Nt","errorLogs":"EditorFooter_errorLogs__2f1OV"};